module.exports = __webpack_public_path__ + "img/weChat_supplier.5eda46d0.png";